import React from 'react';
import styled, { css } from 'styled-components';

const SimpleButton = ({
  children,
  id,
  cursorDisabled,
  onClick = () => {},
  color = 'black',
  backgroundColor = 'white',
  borderColor = 'white',
  borderRadius = '18px',
  width = 'fit-content',
  height = '48px',
  margin = '0px',
  backgroundColorHover = 'white'
}) => {
  return (
    <Button
      onClick={onClick}
      colorText={color}
      backgroundColor={backgroundColor}
      id={id}
      borderColor={borderColor}
      cursorDisabled={cursorDisabled}
      borderRadius={borderRadius}
      width={width}
      height={height}
      margin={margin}
      backgroundColorHover={backgroundColorHover}
    >
      {children}
    </Button>
  );
};

const Button = styled.div`
  cursor: ${({ cursorDisabled }) => (cursorDisabled ? 'not-allowed' : 'pointer')};
  font-weight: 600;
  padding: 0 19px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ borderRadius }) => borderRadius};
  position: relative;
  font-size: 16px;
  > img {
    margin-right: 10px;
  }
  ${({ width, height, colorText, backgroundColor, borderColor, margin, backgroundColorHover, cursorDisabled }) => css`
    color: ${colorText};
    background-color: ${backgroundColor};
    border: 1px solid ${borderColor};
    margin: ${margin};
    width: ${width};
    height: ${height};
    :hover {
      background-color: ${!cursorDisabled && backgroundColorHover};
    }
  `}
`;

export { SimpleButton };
